import React from "react";
import { IoIosArrowForward } from "react-icons/io";

const MahingaHeader = () => {
  return (
    <>
      <section id="hero" className="main-banner">
        <div className="container">
          <div className="breadcrumb-block">
            <h1 className="text-white">Mgahinga Gorilla National Park</h1>
            <div className="breadcrumb-merge-5px-gap">
              <a href="/" className="breadcrumb">
                Home
              </a>
              <div className="icon">
                <IoIosArrowForward />
              </div>
              <a href="/blog" className="breadcrumb">
                Blog
              </a>
              <div className="icon">
                <IoIosArrowForward />
              </div>
              <div className="breadcrumb">
                Uganda’s Smallest but Most Unique Wildlife Haven
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MahingaHeader;
